import styled from '@emotion/styled';
import { Spacings, mediaQuery } from '@styles/index';

const RightContainer = styled.div`
  grid-column: 6/25;

  ${mediaQuery.uptoTablet} {
    grid-column: 1/25;
    margin-left: ${Spacings.SPACING_4B};
    margin-right: ${Spacings.SPACING_4B};
  }
`;

export default RightContainer;
